module.exports = __webpack_public_path__ + "img/Circulo-Logo-TesteoMaterial-Gris.c192768c.png";